export const environment = {
  context: 'development',
  production: false,
  sentry: '',
  auth0: {
    domain: 'dev.login.veratrak.com',
    audience: 'dev-veratrak.eu.auth0.com',
    clientId: 'PaMn-I1c_StOKLsVTC8kMiDUBo8kPIAG'
  },
  api: {
    host: 'https://dev.api.veratrak.com',
    quality: '',
    websocket: 'wss://socket.dev.app.veratrak.com',
  },
  etherscan: 'https://ropsten.etherscan.io/tx/',
  tagManager: 'GTM-5HMDS89',
  featureFlags: {
    vaultGuestDeleteCustomerIds: [
      '81b570b2-43e4-11e9-9549-0242ac130002',
    ] as readonly string[],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
